import React, { useState } from 'react';
import { Button } from 'ui-v2/components/Button';
import { Input } from 'ui-v2/components/Input';
import Modal from 'ui-v2/components/Modal';
import { Typography } from 'ui-v2/components/Typography';
import s from './SuggestProduct.module.scss';
import { trackSuggestProductSubmitted } from '../../utils/events';

type SuggestProductProps = {
  show: boolean;
  onHide: () => void;
};
const suggestProductLabel =
  'Are we missing something? Leave your suggestion here and we will try our best to bring it here for you';

const afterFeedbackSubtitle =
  'We will try and add the suggested product to Park+ store soon';

export const SuggestProduct: React.FunctionComponent<SuggestProductProps> = ({
  show,
  onHide,
}) => {
  // state
  const [value, setValue] = useState('');
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);

  const handleSubmit = () => {
    setFeedbackSubmitted(true);
    trackSuggestProductSubmitted(value);
  };

  return (
    <Modal
      show={show}
      head={{ show: true, onClose: onHide }}
      animation={{ type: 'btt', timeout: 'm' }}
      rootStyle={{ zIndex: 100 }}
      noPadding
    >
      <div className={s.root}>
        {!feedbackSubmitted && (
          <>
            <div className={s.upper}>
              <div className={s.heading}>
                <Typography
                  label="Tell us what you’d like"
                  variant="h_4_bold"
                />
              </div>
              <div className={s.subheading}>
                <Typography
                  label={suggestProductLabel}
                  variant="body_3_medium"
                  color="secondary"
                />
              </div>
              <div className={s.text_input}>
                <Input
                  inputType="text"
                  value={value}
                  onChange={(e: any) => setValue(e.target.value)}
                  placeholder="What would you like to purchase for your car?"
                />
              </div>
            </div>
            <div className={s.btn_div}>
              <Button
                label="Submit"
                onClick={handleSubmit}
                disabled={!value}
                fullWidth
                variant='primary'
                size='medium'
              />
            </div>
          </>
        )}

        {feedbackSubmitted && (
          <div className={s.after_feedback}>
            <div className={s.upper}>
              <div className={s.thumbs_up}>👍</div>
              <div className={s.title}>
                <Typography
                  label="Thank you!"
                  variant="h_4_bold"
                />
              </div>

              <div className={s.subtitle}>
                <Typography
                  label={afterFeedbackSubtitle}
                  variant="body_3_medium"
                  color="secondary"
                />
              </div>
            </div>

            <div className={s.btn_div}>
              <Button variant='primary' size='medium' label="Done" onClick={onHide} fullWidth />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};
